/* NeonGenOverlay — futuristic full-screen "AI is synthesizing" animation.
 * Replaces plain "Generating…" toasts on the Interactive Board. */
import React from "react";
import { createPortal } from "react-dom";

export default function NeonGenOverlay({ label = "Synthesizing image", sub = "neural cores engaged · hold tight" }) {
  return createPortal(
    <div className="neon-gen-overlay" data-testid="neon-gen-overlay">
      <div className="neon-gen-core">
        <div className="ring" />
        <div className="ring r2" />
        <div className="ring r3" />
        <div className="nucleus" />
        <div className="neon-gen-scan" />
      </div>
      <div className="neon-gen-label">{label}</div>
      <div className="neon-gen-bar"><i /></div>
      <div className="neon-gen-sub">{sub}</div>
    </div>,
    document.body
  );
}
